import React from 'react';
import { Calendar } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface CalendarChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const CalendarChartIcon: React.FC<CalendarChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <Calendar size={size} color={color} />
        </IconWrapper>
    );
};
